import { Button } from "~/shadcn/ui/button"
import Text, { H1 } from "~/ui/typography"
import { checkoutStorageKey } from "./AutoCheckoutRedirect"

/**
 * Shown when a self-serve user returns to the choose-plan screen after backing
 * out of Stripe checkout. Their plan is already decided (it's managed in
 * Stripe), so we don't show the multi-plan picker — just a way to resume.
 * Clearing the guard and reloading lets AutoCheckoutRedirect fire again.
 */
export const ResumeCheckoutCard = ({ tierKey }: { tierKey: string }) => {
  const continueToCheckout = () => {
    sessionStorage.removeItem(checkoutStorageKey(tierKey))
    window.location.reload()
  }

  return (
    <div className="flex flex-1 flex-col items-center justify-center py-16 text-center">
      <H1 className="mb-2">Almost there!</H1>
      <Text variant="header3" className="mb-8 max-w-md">
        Finish setting up your account by completing your subscription.
      </Text>
      <Button onClick={continueToCheckout}>Continue to checkout</Button>
    </div>
  )
}
